import * as ace from "ace-builds/src-noconflict/ace";

ace.config.setModuleUrl('ace/theme/chrome', require('file-loader?esModule=false&outputPath=ace!ace-builds/src-noconflict/theme-chrome.js'));
ace.config.setModuleUrl('ace/mode/javascript', require('file-loader?esModule=false&outputPath=ace!ace-builds/src-noconflict/mode-javascript.js'));
ace.config.setModuleUrl('ace/mode/javascript_worker', require('file-loader?esModule=false&outputPath=ace!ace-builds/src-noconflict/worker-javascript.js'))

import "ace-builds/src-noconflict/mode-javascript";
import * as ko from "knockout";

const bindingName = "ace";

interface BindingAce {
    value: KnockoutObservable<string>;
    ReadonlyRange: ace.Range[];
    init: (config: any) => void;
}

class AceBinding {
    public Value: KnockoutObservable<string>;
    public Editor: ace.Editor;

    private readyOnlyRanges: ace.Range[] = [];
    private readOnlyMarker = [];
    constructor(element: HTMLElement, valueAccessor: () => BindingAce) {
        element.attributes["height"] = "500px";
        this.Editor = ace.edit(element);
        // this.Editor.setTheme(theme_monokai);
        this.Editor.setOptions({
            fontSize: "16px"
        });
        this.Editor.$blockScrolling = Infinity;
        this.Editor.setShowPrintMargin(false);
        const session = this.Editor.getSession();
        session.setMode("ace/mode/javascript");
        const v = valueAccessor().value;
        this.Value = v;
        if (typeof ko.unwrap(v) === "string") {
            session.setValue(ko.unwrap(valueAccessor().value));
        }
        session.on("change", (e) => {
            if (ko.isObservable(this.Value)) {
                this.Value(session.getValue());
            }
        });
        this.initReadyOnlyRange(valueAccessor().ReadonlyRange);

        if (valueAccessor() != null) {
            valueAccessor().init({
                Editor: this.Editor,
                SetReadonlyRange: this.setReadonlyRange
            });
        }
    }

    private handleReadonlyKeyboard = (data, hash, keyString, keyCode, event) => {
        if (hash === -1 || (keyCode <= 40 && keyCode >= 37)) {
            return null;
        }
        if (this.readonlyIntersect()) {
            return { command: "null", passEvent: false };
        }
        return null;
    }

    private readonlyIntersect = () => {
        let returnValue = false;
        const selectionRange = this.Editor.getSelectionRange();
        for (let i = 0; i < this.readyOnlyRanges.length; i++) {
            if (selectionRange.intersects(this.readyOnlyRanges[i])) {
                returnValue = true;
                break;
            }
        }
        return returnValue;
    }

    private preventReadonly = (next, args) => {
        if (this.readonlyIntersect()) {
            return;
        }
        next();
    }

    private before(obj, method, wrapper) {
        const orig = obj[method];
        obj[method] = function () {
            const args = Array.prototype.slice.call(arguments);
            return wrapper.call(this, function () {
                return orig.apply(obj, args);
            }, args);
        };
        return obj[method];
    }
    private initReadyOnlyRange(ranges: any) {
        this.setReadonlyRange(ranges);
        this.Editor.keyBinding.addKeyboardHandler({ handleKeyboard: this.handleReadonlyKeyboard }, null);
        this.before(this.Editor, "onPaste", this.preventReadonly);
        this.before(this.Editor, "onCut", this.preventReadonly);
    }

    private setReadonlyRange = (ranges: any) => {
        this.resetReadonlyRange();
        const AceRange = ace.require("ace/range");
        const session = this.Editor.getSession();
        if (ranges != null) {
            for (let i = 0; i < ranges.length; i++) {
                const definition = ranges[i];
                const r = new AceRange.Range(definition.StartRow, definition.StartColumn, definition.EndRow, definition.EndColumn);
                this.readyOnlyRanges.push(r);
                const markerId = session.addMarker(r, "readonly-highlight", "", false);
                this.readOnlyMarker.push(markerId);
                r.start = session.doc.createAnchor(r.start.row, r.start.column);
                r.end = session.doc.createAnchor(r.end.row, r.end.column);
            }
        }
    }

    private resetReadonlyRange = () => {
        const session = this.Editor.getSession();
        for (let i = 0; i < this.readOnlyMarker.length; i++) {
            session.removeMarker(this.readOnlyMarker[i]);
        }
        this.readOnlyMarker = [];
        this.readyOnlyRanges = [];
    }
}

ko.bindingHandlers[bindingName] = {
    init: function (element, valueAccessor: () => BindingAce) {
        console.log("em!");
        let inst = new AceBinding(element, valueAccessor);
        $(element).data("binding-" + bindingName, inst);
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            inst.Editor.destroy();
            $(element).removeData("binding-" + bindingName);
            inst = null;
        });
    }
};